import * as types from "../constants/collectionConstants";

let initialState = {
  trainedData: [],
  instructionData: '',
  collectionSource: "",
  collectionDocs: []
};

const collectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_TRAINED_DATA:
      return { ...state, trainedData: action.trainedData };
    case types.DELETE_TRAINED_DATA:
      return { ...state, trainedData: action.trainedData };
    case types.GET_CHAT_HISTORY_DATA:
      return { ...state, chatHistoryData: action.chatHistoryData };
    case types.GET_WALKTHROUGHS_DATA:
      return {
        ...state,
        walkthroughsData: action.walkthroughsData,
        instructionData: action.instructionData,
        collectionSource: action.collectionSource,
        collectionDocs: action.collectionDocs,
        systemPrompt: action.systemPrompt,
        preprocessingInstuctions: action.preprocessingInstuctions,
      };
    case types.UPDATE_COLLECTION_DOCS_LIST:
      return {
        ...state,
        collectionDocs: action.collectionDocs
      };
    default:
      return state;
  }
};

export default collectionReducer;
